import { Injectable } from '@angular/core';
import { BaseControl, Custom, DateTimePicker, Textbox, ModeloBase } from '@app/shared';
import { Boletines } from '../../../../shared/models/publicacion.model';
import { Validators } from '@angular/forms';

@Injectable()
export class BulletinsFormService {
  constructor() { }

  
  
  /**
   *  Construye y retorna el formulario para modificar una publicacion
   *
   * @param {TemplateRef<any>} templateUpload
   * @param {Publicacion} [publicacion]
   * @return {*}  {BaseControl<any>[]}
   * @memberof PublicationsFormService
   */
  getFormBulletin(template: any, options: any,
    bulletin?: Boletines
  ): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Textbox({
        key: 'codigo',
        value: bulletin && bulletin.codigo ? bulletin.codigo : null,
        label: 'Código',
        placeholder: 'Codigo',
        order: 1,
        validations: {
          validators: [Validators.required]
        }
      }),
      new Custom({
        key: 'mes',
        label: 'Mes de emisión del boletín:',
        value: bulletin && bulletin.mes ? bulletin.mes : null,
        template: template,
        options: options,
        order: 2,
        placeholder: 'Seleccione un mes',
        validations: {
          validators: [Validators.required]
        }
      }),
      new Textbox({
        key: 'ano',
        type: 'number',
        value: bulletin && bulletin.ano ? bulletin.ano : null,
        label: 'Año',
        placeholder: 'Año',
        order: 3,
        validations: {
          validators: [
            Validators.minLength(4),
            Validators.maxLength(4),
            Validators.required],
          messages: {
            min: 'La longitud del año debe tener 4 digitos'
          }
        }
      })
    ];

    return controls.sort((a, b) => a.order - b.order);
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/publications-bulletin-management/bulletins/shared/bulletins.form.service.ts